import React from 'react';
import Header from '../Header';
import { Flex } from 'rebass';
import PropTypes from 'prop-types';

type LayoutProps = {
  children?: React.ReactNode;
};

/**
 * @component for page layout
 */
const Layout = (props: LayoutProps): JSX.Element => {
  return (
    <>
      <Header />
      <Flex
        as="main"
        bg="background"
        color="text"
        flexDirection="column"
        // assume full height
        sx={{
          height: 'calc(100vh - 50px)',
          background: 'linear-gradient(0deg, #fff, #fff, #f1f1f1)',
        }}
      >
        {props.children}
      </Flex>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
